var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafariBurgerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "25 25 450 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hamburger-top-line",
    strokeWidth: 50,
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "none",
    d: "M50,50 L450,50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "hamburger-middle-line",
    strokeWidth: 50,
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "none",
    d: "M50,225 L450,225"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "hamburger-bottom-line",
    strokeWidth: 50,
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "none",
    d: "M50,400 L450,400"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariBurgerIcon);
export default __webpack_public_path__ + "static/media/safari_burger_icon.46562c50450780be827746cb62bb7bd1.svg";
export { ForwardRef as ReactComponent };